<template>
  <b-container id="fiche_container" v-if="runner">
    <b-row>
      <b-col>
        <div id="live_submenu">
          <BackButton></BackButton>
          <ShareButton></ShareButton>
          <FavoriteButton v-if="runner.id" :id_coureur="runner.id"></FavoriteButton>
        </div>
      </b-col>
    </b-row>
    <transition name="fade" v-if="runner_loaded && !$store.state.loading && runner.identite">
      <b-row>
        <b-col class="content_container d-flex flex-column gap-2">
          <Loading v-if="$store.state.loading"></Loading>
          <div class="d-flex flex-row flex-wrap gap-2 align-items-center justify-content-between">
            <EnteteCoureur :runner="runner"></EnteteCoureur>
            <CotationAndTracking :runner="runner"></CotationAndTracking>
          </div>

          <SubEnteteCoureur :runner="runner"></SubEnteteCoureur>
          <StatutCoureur :runner="runner"></StatutCoureur>
          <PenalitesCoureur :runner="runner"></PenalitesCoureur>
          <InfosPCCourseCoureur v-if="$store.getters['authAdmin/hasAdminRights']" :runner="runner"
            @statut-coureur-changed="fetchCoureurData">
          </InfosPCCourseCoureur>

          <EstimationPassagesCoureur v-if="runner.estimation" :estimation="runner.estimation"
            :statut_course="runner.statut_course" :cote_itra="runner.identite.itra">
          </EstimationPassagesCoureur>
          <MapCoureur v-if="runner.lines && runner.lines.length > 0" :lines="runner.lines" :coureur="runner"
            :focus_point="focus_point">
          </MapCoureur>
          <ProfilCoureur v-if="runner.lines && runner.lines.length > 0" :lines="runner.lines" :coureur="runner"
            :focus_point="focus_point" v-on:focus_point="setFocusPoint"></ProfilCoureur>

          <div v-if="!runner_loaded && !$store.state.loading">
            <h3>{{ $t("fiche.erreur_chargement") }}</h3>
            <BackButton></BackButton>
          </div>
        </b-col>
      </b-row>
    </transition>
  </b-container>
</template>

<script>
import Runner from "@/classes/Runner/runner.class";
import axios from "axios";
import BackButton from "@/components/App/UI/BackButton.vue";
import PassagesCoureur from "@/components/Live_tab/PassagesCoureur.vue";
import EstimationPassagesCoureur from "@/components/FicheCoureur/EstimationPassagesCoureur.vue";
import InfosPCCourseFiche from "@/components/Live_tab/PCCourse/InfosPCCourseFiche.vue";
import MapCoureur from "@/components/FicheCoureur/MapCoureur.vue";
import ProfilCoureur from "@/components/FicheCoureur/ProfilCoureur.vue";
import InfoLocalisation from "@/components/Live_tab/InfoLocalisation.vue";
import Loading from "@/components/Loading.vue";
import SelectFondMap from "@/components/FondMapSelector.vue";
import ShareButton from "@/components/App/UI/ShareButton.vue";
import FavoriteButton from "@/components/App/UI/FavoriteButton.vue";
import EnteteCoureur from "@/components/FicheCoureur/EnteteCoureur.vue";
import CotationAndTracking from "@/components/FicheCoureur/CotationAndTracking.vue";
import PenalitesCoureur from "@/components/FicheCoureur/PenalitesCoureur.vue";
import StatutCoureur from "@/components/FicheCoureur/StatutCoureur.vue";
import SubEnteteCoureur from "@/components/FicheCoureur/SubEnteteCoureur.vue";
import InfosPCCourseCoureur from "@/components/FicheCoureur/InfosPCCourseCoureur.vue";
export default {
  components: {
    PassagesCoureur,
    MapCoureur,
    ProfilCoureur,
    Loading,
    InfoLocalisation,
    SelectFondMap,
    InfosPCCourseFiche,
    EstimationPassagesCoureur,
    PenalitesCoureur,
    BackButton,
    ShareButton,
    FavoriteButton,
    EnteteCoureur,
    CotationAndTracking,
    StatutCoureur,
    SubEnteteCoureur,
    InfosPCCourseCoureur,
  },

  watch: {
    "$route.params.id_coureur": {
      async handler(newId, oldId) {
        if (oldId && newId !== oldId) {
          this.$store.commit("clearRefreshIntervals");
          this.$store.commit("clearRefreshTempsCourseIntervals");
          this.$store.commit("setLoading");
          await this.initRunner();
          this.countdownRefresh();
          this.$forceUpdate();
        }
      },
    },
  },

  data() {
    return {
      runner_loaded: false,
      runner: null,
      focus_point: 0,
    };
  },


  methods: {

    setFocusPoint(p) {
      this.focus_point = p;
    },

    async fetchCoureurData() {
      if (!this.runner) {
        return;
      }
      const fetched = await this.runner.fetch();
      if (fetched) {
        this.runner_loaded = true;
      } else {
        this.runner_loaded = false;
      }
      this.$forceUpdate();
    },


    countdownRefresh() {
      if (!this.$store.state.live_en_cours) {
        this.$store.commit("clearRefreshIntervals");
        return;
      }
      var _this = this;
      var intervalObject = setInterval(function () {
        _this.$store.commit("clearRefreshIntervals");
        _this.fetchCoureurData();
        _this.countdownRefresh();
      }, this.$store.state.refresh_time_carte);
      this.$store.state.refreshIntervals.push(intervalObject);
    },
    async initRunner() {
      this.runner = new Runner(this.$store.state.module.id, this.$route.params.id_coureur, this.$store.state.module.id_live);
      this.runner.setLoadAsPcCourse(this.$store.getters['authAdmin/hasAdminRights']);
      await this.runner.fetch();
      await this.runner.buildLines();
      this.$store.commit("unsetLoading");
      this.runner_loaded = true;
    },


  },
  async mounted() {
    this.$store.commit("clearRefreshIntervals");
    this.$store.commit("clearRefreshTempsCourseIntervals");
    this.$store.commit("setLoading");
    await this.initRunner();
    this.countdownRefresh();
    this.$forceUpdate();
  },
  beforeDestroy() {
    this.$store.commit("clearRefreshIntervals");
    this.$store.commit("clearRefreshTempsCourseIntervals");
  },
};
</script>

<style lang="scss" scoped></style>